import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import { RootState } from "../store";
import { IGlobalInventoryRawItem } from "@src/store/pricing/queryGlobalInventorySlice";
import { getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

interface Item {
	Item_ID: number;
	PDF_FilePath: string;
	Remove_Barcodes: boolean;
}
const initialState = false;

export const { thunk: deletePdfs, slice: deletePdfsSlice } = getThunkAndSlice<Array<Item>, typeof initialState>({
	initialState,
	path: "/api/System/DeletePdfs",
	method: "delete",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const eventId = getInventoryCacheEventId(rootState);
		const inventoryAllState = rootState.pricing.eventInventoryAll.data;

		const newData = inventoryAllState.map((x) => (x.Item_ID === params[0].Item_ID ? { ...x, PDF_Attached: false } : x));

		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<IGlobalInventoryRawItem>).map((x) => {
				return x.Listing_ID === params[0].Item_ID ? { ...x, PdfsAttached: Math.max(0, (x.PdfsAttached ?? 0) - 1) } : x;
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
